import type { ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import type { GoogleDistanceMatrixGetDistanceParams } from './schema';

export const getDistanceParamsSchema = yup
  .object<ObjectType<GoogleDistanceMatrixGetDistanceParams>>()
  .shape({
    organization: yup.string().required(),
    patient: yup.string().required(),
  });
